export const SET_MODULES_CLE_LOADING = "SET_MODULES_CLE_LOADING";
export const SET_MODULES_CLE_BULK_LOADING = "SET_MODULES_CLE_BULK_LOADING";
export const SET_MODULES_CLE_ERROR = "SET_MODULES_CLE_ERROR";

export const FETCH_MODULES_CLE_REQUEST = "FETCH_MODULES_CLE_REQUEST";
export const FETCH_MODULES_CLE_SUCCESS = "FETCH_MODULES_CLE_SUCCESS";
export const FETCH_MODULES_CLE_FAIL = "FETCH_MODULES_CLE_FAIL";

export const CREATE_MODULE_CLE_REQUEST = "CREATE_MODULE_CLE_REQUEST";
export const CREATE_MODULE_CLE_SUCCESS = "CREATE_MODULE_CLE_SUCCESS";
export const CREATE_MODULE_CLE_FAIL = "CREATE_MODULE_CLE_FAIL";

export const UPDATE_MODULE_CLE_REQUEST = "UPDATE_MODULE_CLE_REQUEST";
export const UPDATE_MODULE_CLE_SUCCESS = "UPDATE_MODULE_CLE_SUCCESS";
export const UPDATE_MODULE_CLE_FAIL = "UPDATE_MODULE_CLE_FAIL";

export const DELETE_MODULE_CLE_REQUEST = "DELETE_MODULE_CLE_REQUEST";
export const DELETE_MODULE_CLE_SUCCESS = "DELETE_MODULE_CLE_SUCCESS";
export const DELETE_MODULE_CLE_FAIL = "DELETE_MODULE_CLE_FAIL";

export const DOWNLOAD_MODULE_CLE_TEMPLATE_REQUEST = "DOWNLOAD_MODULE_CLE_TEMPLATE_REQUEST";
export const DOWNLOAD_MODULE_CLE_TEMPLATE_SUCCESS = "DOWNLOAD_MODULE_CLE_TEMPLATE_SUCCESS";
export const DOWNLOAD_MODULE_CLE_TEMPLATE_FAIL = "DOWNLOAD_MODULE_CLE_TEMPLATE_FAIL";

export const IMPORT_MODULE_CLE_EXCEL_REQUEST = "IMPORT_MODULE_CLE_EXCEL_REQUEST";
export const IMPORT_MODULE_CLE_EXCEL_SUCCESS = "IMPORT_MODULE_CLE_EXCEL_SUCCESS";
export const IMPORT_MODULE_CLE_EXCEL_FAIL = "IMPORT_MODULE_CLE_EXCEL_FAIL";
export const CLEAR_MODULE_CLE_IMPORT_RESULT = "CLEAR_MODULE_CLE_IMPORT_RESULT";

export const setModulesCleLoading = (v) => ({ type: SET_MODULES_CLE_LOADING, payload: v });
export const setModulesCleBulkLoading = (v) => ({ type: SET_MODULES_CLE_BULK_LOADING, payload: v });
export const setModulesCleError = (msg) => ({ type: SET_MODULES_CLE_ERROR, payload: msg });
export const clearModuleCleImportResult = () => ({ type: CLEAR_MODULE_CLE_IMPORT_RESULT });

export const fetchModulesCleRequest = () => ({ type: FETCH_MODULES_CLE_REQUEST });
export const fetchModulesCleSuccess = (data) => ({ type: FETCH_MODULES_CLE_SUCCESS, payload: data });
export const fetchModulesCleFail = (err) => ({ type: FETCH_MODULES_CLE_FAIL, payload: err });

export const createModuleCleRequest = (payload) => ({ type: CREATE_MODULE_CLE_REQUEST, payload });
export const createModuleCleSuccess = (data) => ({ type: CREATE_MODULE_CLE_SUCCESS, payload: data });
export const createModuleCleFail = (err) => ({ type: CREATE_MODULE_CLE_FAIL, payload: err });

export const updateModuleCleRequest = (id, payload) => ({
    type: UPDATE_MODULE_CLE_REQUEST,
    payload: { id, payload },
});
export const updateModuleCleSuccess = (data) => ({ type: UPDATE_MODULE_CLE_SUCCESS, payload: data });
export const updateModuleCleFail = (err) => ({ type: UPDATE_MODULE_CLE_FAIL, payload: err });

export const deleteModuleCleRequest = (id) => ({ type: DELETE_MODULE_CLE_REQUEST, payload: { id } });
export const deleteModuleCleSuccess = (id) => ({ type: DELETE_MODULE_CLE_SUCCESS, payload: id });
export const deleteModuleCleFail = (err) => ({ type: DELETE_MODULE_CLE_FAIL, payload: err });

export const downloadModuleCleTemplateRequest = () => ({ type: DOWNLOAD_MODULE_CLE_TEMPLATE_REQUEST });
export const importModuleCleExcelRequest = (file, { dryRun = true, action = "add" } = {}) => ({
    type: IMPORT_MODULE_CLE_EXCEL_REQUEST,
    payload: { file, dryRun, action },
});
